import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@shared/hooks/useAuth";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  redirectTo?: string;
}

export function ProtectedRoute({
  children,
  requireAdmin = true,
  redirectTo = "/login",
}: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Si está autenticado y cumple los requisitos, mostrar el contenido
  return <>{children}</>;
}
